import { MAX_DOCUMENT_REFERENCES } from "@common/schemas/documentReference.schema";
import { useDocumentRefContextMaybe } from "./DocumentRefContext";
import {
    AskAboutDocument,
    buildDocumentReferences,
} from "./buildDocumentReferences";
import { useAddToChat } from "./useAddToChat";

const buildDocumentRefs = ({
    taskId,
    items,
}: {
    taskId: string;
    items: AskAboutDocument[];
}) => buildDocumentReferences({ taskId, documents: items });

/**
 * Adds financial documents to the open task's chat; shared by the GetDocuments,
 * Upload Statements and financial documents task bodies and their row drag.
 * Callers own their selection state and clear it after `addDocumentsToChat`.
 */
export function useAddDocumentsToChat() {
    const { canAddToChat, addToChat } = useAddToChat({
        draftRefsState: useDocumentRefContextMaybe(),
        maxRefs: MAX_DOCUMENT_REFERENCES,
        noun: "document",
        buildRefs: buildDocumentRefs,
    });

    return { canAddToChat, addDocumentsToChat: addToChat };
}
